/**
 * Created by Andromeda on 11/19/16.
 */
'use strict';
//bids
import './assets/css/bids.css';
import './assets/css/steps/jquery.steps.css';
import './assets/css/switchery.css';

require('./assets/js/steps/jquery.steps.min.js');
require('./assets/lib/angular-ui-mask/dist/mask.js');


// WEBPACK FOOTER //
// ./packages/custom/bids/public/index.js